document.addEventListener("DOMContentLoaded", function () {
  loadLoader();
});

document.addEventListener("shopify:section:load", function () {
  loadLoader();
});

function loadLoader() {
  const targetNode = document.querySelector('div[slot="content"].md\\:grid.md\\:grid-cols-2');

  const quantityElm = `
    <div class="flex items-center mb-3 md:mb-4" style="justify-content: space-between;">
      <legend class="label label-product-info">Quantity</legend>
    </div>
    <qty-selector class="qty-selector">
      <button type="button" data-dec class="button button-light qty-selector__button">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line shape-rendering="crispEdges" y1="32" x2="64" y2="32" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
        </svg>
      </button>

      <input id="quantity" name="quantity"  type="number" class="hide-input-arrows" min="1" value="1">

      <button type="button" data-inc class="button button-light qty-selector__button">
        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line shape-rendering="crispEdges" x1="32" y1="0" x2="32" y2="64" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
          <line shape-rendering="crispEdges" y1="32" x2="64" y2="32" stroke="currentColor" stroke-width="var(--stroke-width, 10)"></line>
        </svg>
      </button>
    </qty-selector>
  `;

  if (!targetNode) {
    console.warn('Target element not found: <div slot="content" class="md:grid md:grid-cols-2">');
    return;
  }

  let timeoutId = null;

  const handleMutations = (mutationsList) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      mutationsList.forEach(() => {
        const quickAddModal = document.querySelector("quick-add-modal");

        if (quickAddModal) {
          const productForm = quickAddModal.querySelector("product-form #Product-Form-product-quick-add-modal");

          if (productForm && !productForm.querySelector(".qty-selector")) {
            productForm.insertAdjacentHTML("afterbegin", quantityElm);
          }
        }
      });
    }, 50);
  };

  const observerConfig = {
    attributes: true,
    subtree: true,
  };

  const observer = new MutationObserver(handleMutations);
  observer.observe(targetNode, observerConfig);

  console.log('MutationObserver is watching <div slot="content" class="md:grid md:grid-cols-2"> for changes.');
}


// color swatch card
const handleize = (str) => {
  return str
    .toLowerCase()
    .trim()
    .replace(/['"]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

class ProductCardColors extends HTMLElement {
  connectedCallback() {
    this.renderColors();
  }

  get styleCode() {
    return this.dataset.styleCode;
  }

  get productType() {
    return this.dataset.colorType;
  }

  get colorSwatches() {
    return this.dataset.colorSwatches || "";
  }

  get currentProductId() {
    return Number(this.dataset.productId);
  }

  async renderColors() {
    if (!this.styleCode) return;

    const { products, patterns } = await this.getRelatedProducts(this.styleCode);
    if (!products?.length) return;

    let filterdProducts = products;

    if(this.productType){
      filterdProducts = products.filter((p) => patterns[p.handle] === this.productType);
    }

    
    // ✅ Filter only solid pattern products

    if (!filterdProducts.length) return; // no solids found

    if(this.querySelector(".pf-color-wrapper")){
      this.querySelector(".pf-color-wrapper").remove();
    }

    const wrapper = document.createElement("div");
    wrapper.classList.add("pf-color-wrapper");

    const swatchLines = this.colorSwatches.split(/\r?\n/);

    const MAX_VISIBLE = 5;
    const remaining = products.length - MAX_VISIBLE;


    // ✅ Render first 5 solid colors only
    filterdProducts.slice(0, MAX_VISIBLE).forEach((product) => {
      wrapper.appendChild(this.createColorButton(product, swatchLines));
    });

    // ✅ Add "+X more" button (redirect to product page)
    if (remaining > 0) {
      const productUrl = this.getAttribute("product-url") || window.location.pathname;
      const moreBtn = document.createElement("button");
      moreBtn.className = "color-swatch-more";
      moreBtn.textContent = `+${remaining} more`;
      moreBtn.addEventListener("click", () => (window.location.href = productUrl));
      wrapper.appendChild(moreBtn);
    }

    this.appendChild(wrapper);
  }

  createColorButton(product, swatchLines) {
    const color = product.variants?.[0]?.option1;
    if (!color) return document.createDocumentFragment();

    const handle = product.handle;
    const id = product.id;
    const featuredImage = product.featured_image;
    const isActive = id === this.currentProductId;

    const currentColor = handleize(color);
    let colorValue = null;

    swatchLines.forEach((line) => {
      const [name, value] = line.split(":").map((s) => s.trim());
      if (!name || !value) return;
      if (currentColor === handleize(name)) {
        colorValue = value;
      }
    });

    let style = /\.(jpg|png)$/i.test(colorValue)
      ? `background-image: url('https://cdn.shopify.com/s/files/1/0645/1996/2668/files/${colorValue}')`
      : `background: ${colorValue}`;

    if (!colorValue) style = `background-image: url('${featuredImage}')`;

    const aTag = document.createElement("a");
    aTag.className = `pf-color-swatch ${isActive ? "is-selected" : ""}`;
    aTag.href = `/products/${handle}`;
    aTag.dataset.colorName = color;
    aTag.dataset.productHandle = handle;
    aTag.dataset.productId = id;

    aTag.innerHTML = `
      <span class="pf-color-icon" style="${style};"></span>
      <p class="pf-color-tooltip"><span>${color}</span></p>
    `;

    return aTag;
  }

  async getRelatedProducts(styleCode) {
    try {
      const productsObj = {
        products: [],
        patterns: {},
        totalPatterns: 0,
        solidPatterns: 0,
        printedPatterns: 0,
      };

      const url = `/collections/all?filter.p.m.custom.ap21_style_code=${styleCode}&section_id=main-collection-grid`;
      const response = await fetch(url);
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const jsonElement = doc.querySelector(".pf-products-json");

      if (!jsonElement) {
        console.warn("No .pf-products-json element found in response");
        return productsObj;
      }

      try {
        productsObj.products = JSON.parse(jsonElement.dataset.products);

        const patternTypesArr = (jsonElement.dataset.patternTypes || "").split(",");
        patternTypesArr.forEach((patternStr) => {
          const patternArr = (patternStr || "").split(":");
          if (!patternArr[0]) return;

          if (patternArr[1] == "solid") {
            productsObj.solidPatterns++;
            productsObj.totalPatterns++;
          } else if (patternArr[1] == "printed") {
            productsObj.printedPatterns++;
            productsObj.totalPatterns++;
          }

          productsObj.patterns[patternArr[0]] = patternArr[1] || "";
        });

        return productsObj;
      } catch (err) {
        console.error("Error parsing .pf-products-json JSON", err);
        return productsObj;
      }
    } catch (error) {
      console.error("Error loading related products:", error);
      return productsObj;
    }
  }
}

if (!customElements.get("product-card-colors")) {
  customElements.define("product-card-colors", ProductCardColors);
}